module.exports = __webpack_public_path__ + "img/phone-incoming-outgoing.1e3af9ac.svg";